/**
 * @module cc
 */
/**
 * Class for TTFFont handling.
 * @class TTFFont
 * @extends Asset
 * @constructor
 */
var TTFFont = cc.Class({
    name: 'cc.TTFFont',
    extends: cc.Font
});

cc.TTFFont = TTFFont;
module.exports = TTFFont;
